module.exports = __webpack_public_path__ + "img/Reydar_Download_Scan_Discover.8359fba1.png";